import http from "./AxiosInstance";

class StockService {
  // Défauts/avaries
  createDefect(data) {
    return http.post("/stock/defects/create", data);
  }

  updateDefect(data, id) {
    return http.put(`/stock/update/${id}`, data);
  }

  deleteDefect(id) {
    return http.delete(`/stock/defects/${id}`);
  }

  getDefects() {
    return http.get("/stock/defects/all");
  }

  // Gestion du stock
  getStockActuel(page = 1, limit = 100) {
    return http.get("/stock/actuel");
  }

  getHistoriqueStock(page = 1, limit = 100) {
    return http.get("/stock/historique");
  }

  getProduitsRupture() {
    return http.get("/stock/rupture");
  }

  getProduitsExpiration() {
    return http.get("/stock/expiration/bientot");
  }

  getStatistiquesStock() {
    return http.get("/stock/statistiques");
  }

  ajusterStock(data) {
    return http.post("/stock/ajuster", data);
  }

  synchroniserStock() {
    return http.post("/stock/synchroniser");
  }

  getRapportJournalier(date = null) {
    const params = date ? { date } : {};
    return http.get("/stock/rapport/journalier", { params });
  }


   // =========================================================================
  // NOUVELLES MÉTHODES POUR LES MOUVEMENTS DE STOCK
  // =========================================================================

  // MOUVEMENTS PAR PRODUIT
  getMouvementsProduit(codeIdProd) {
    return http.get(`/mouvements/produit/${codeIdProd}`);
  }

  // MOUVEMENTS PAR COMMANDE
  getMouvementsCommande(idBonDeComdeMat) {
    return http.get(`/mouvements/commande/${idBonDeComdeMat}`);
  }

  // JOURNAL DES MOUVEMENTS PAR DATE
  getMouvementsJournal(date) {
    return http.get(`/mouvements/journal/${date}`);
  }

  // STATISTIQUES GÉNÉRALES
  getStatistiquesGenerales() {
    return http.get("/statistiques/generales");
  }

  // STATISTIQUES MENSUELLES
  getStatistiquesMensuelles() {
    return http.get("/statistiques/mensuelles");
  }

  // TOP PRODUITS
  getTopProduits() {
    return http.get("/statistiques/top-produits");
  }

  // STATISTIQUES PAR TYPE
  getStatistiquesParType() {
    return http.get("/statistiques/par-type");
  }

  // HISTORIQUE AVEC PAGINATION ET FILTRES
  // StockService.js - Modifiez la méthode getHistoriqueMouvements
getHistoriqueMouvements(params = {}) {
  const { page = 1, limit = 1000, type, date_debut, date_fin } = params; // Augmentez la limite à 1000 ou plus
  return http.get("/mouvements/historique", {
    params: {
      page,
      limit,
      type,
      date_debut,
      date_fin
    }
  });
}

  // SOLDES DES PRODUITS
  getSoldesProduits() {
    return http.get("/statistiques/soldes-produits");
  }

  // ALERTES STOCK
  getAlertesStock() {
    return http.get("/statistiques/alertes");
  }

  // MOUVEMENTS PAR FOURNISSEUR
  getMouvementsParFournisseur() {
    return http.get("/statistiques/par-fournisseur");
  }

  // DASHBOARD MOUVEMENTS
  getDashboardMouvements() {
    return http.get("/dashboard");
  }

  // EXPORT DES MOUVEMENTS
  exportMouvements(format = 'json') {
    return http.get("/mouvements/export", {
      params: { format },
      responseType: format === 'csv' ? 'blob' : 'json'
    });
  }

  // RECHERCHE AVANCÉE DES MOUVEMENTS
  rechercherMouvements(criteres) {
    return http.get("/mouvements/recherche", { params: criteres });
  }


}

const stockService = new StockService();
export default stockService;